// Shared variant-photo editing state for the inline variant editors
// (VariantDetailsModal.vue and ItemVariantView.vue).

export function revokeBlobUrl(url) {
  if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
}

export function initialImageTemp(variant) {
  return {
    image_file: null,
    image_preview: variant.small_thumb || variant.image || '',
    remove_image: false,
  };
}

export function selectTempImage(temp, file) {
  revokeBlobUrl(temp.image_preview);
  temp.image_file = file;
  temp.image_preview = URL.createObjectURL(file);
  temp.remove_image = false;
}

export function clearTempImage(temp, variant) {
  revokeBlobUrl(temp.image_preview);
  temp.image_file = null;
  temp.image_preview = '';
  temp.remove_image = !!variant.image;
}

/**
 * PATCH item/variants/:pk/. Plain JSON unless the photo changed, in which case multipart
 * (empty string clears a nullable field, like null does in JSON).
 */
export function patchVariant(axios, url, fields, temp) {
  if (!temp.image_file && !temp.remove_image) return axios.patch(url, fields);

  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value ?? '');
  });
  if (temp.image_file) formData.append('image', temp.image_file);
  if (temp.remove_image) formData.append('remove_image', 'true');
  // The shared axios instance defaults to JSON, which makes axios serialize FormData to JSON
  // and drop the file.
  return axios.patch(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
}
